<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 搜索条件 -->
      <div class="table-page-search-wrapper" style="margin-bottom: 16px">
        <a-form layout="inline">
          <a-row :gutter="24">
            <a-col :span="8">
              <a-form-item label="供应商名称">
                <a-input v-model="queryParam.supplierName" placeholder="请输入供应商名称" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item>
                <a-button type="primary" @click="handleQuery">
                  <a-icon type="search" />查询
                </a-button>
                <a-button style="margin-left: 8px" @click="resetQuery">
                  <a-icon type="redo" />重置
                </a-button>
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
      </div>

      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="$refs.supplierForm.handleAdd()" v-hasPermi="['retail:supplier:add']">
          <a-icon type="plus" />新增供应商
        </a-button>
      </div>

      <!-- 供应商表单 -->
      <supplier-form ref="supplierForm" @ok="getList" />

      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :pagination="pagination"
        @change="handleTableChange"
        :bordered="tableBordered"
      >
        <span slot="supplierName" slot-scope="text">
          {{ text }}
        </span>
        <span slot="address" slot-scope="text">
          {{ text || '-' }}
        </span>
        <span slot="contactPerson" slot-scope="text">
          {{ text || '-' }}
        </span>
        <span slot="contactPhone" slot-scope="text">
          {{ text || '-' }}
        </span>
        <span slot="createTime" slot-scope="text">
          {{ text || '-' }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a @click="handleEdit(record)" style="margin-right: 8px" v-hasPermi="['retail:supplier:edit']">
            <a-icon type="edit" />编辑
          </a>
          <a-popconfirm
            title="确定删除这个供应商吗?"
            @confirm="handleDelete(record)"
            v-hasPermi="['retail:supplier:remove']"
          >
            <a style="color: #ff4d4f">
              <a-icon type="delete" />删除
            </a>
          </a-popconfirm>
        </span>
      </a-table>
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { getSupplierList, removeSupplier } from '@/api/retail/supplier'
import SupplierForm from './modules/SupplierForm'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'Supplier',
  components: {
    SupplierForm
  },
  mixins: [tableMixin],
  data() {
    return {
      list: [],
      loading: false,
      queryParam: {
        supplierName: undefined
      },
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        showTotal: total => `共 ${total} 条`
      },
      columns: [
        {
          title: '供应商名称',
          dataIndex: 'supplierName',
          width: 200,
          scopedSlots: { customRender: 'supplierName' },
          align: 'center'
        },
        {
          title: '地址',
          dataIndex: 'address',
          width: 300,
          ellipsis: true,
          scopedSlots: { customRender: 'address' },
          align: 'center'
        },
        {
          title: '联系人',
          dataIndex: 'contactPerson',
          width: 120,
          scopedSlots: { customRender: 'contactPerson' },
          align: 'center'
        },
        {
          title: '联系电话',
          dataIndex: 'contactPhone',
          width: 150,
          scopedSlots: { customRender: 'contactPhone' },
          align: 'center'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          width: 180,
          scopedSlots: { customRender: 'createTime' },
          align: 'center'
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: 150,
          fixed: 'right',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      this.loading = true
      const params = {
        ...this.queryParam,
        current: this.pagination.current,
        size: this.pagination.pageSize
      }
      getSupplierList(params).then(response => {
        if (response.data) {
          this.list = response.data.records || []
          this.pagination.total = response.data.total || 0
        } else if (Array.isArray(response)) {
          this.list = response
        } else {
          this.list = []
          this.pagination.total = 0
        }
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    handleQuery() {
      this.pagination.current = 1
      this.getList()
    },
    resetQuery() {
      this.queryParam = {
        supplierName: undefined
      }
      this.pagination.current = 1
      this.getList()
    },
    handleTableChange(pagination) {
      this.pagination = pagination
      this.getList()
    },
    handleEdit(record) {
      this.$refs.supplierForm.handleEdit(record)
    },
    handleDelete(record) {
      removeSupplier({ id: record.id }).then(() => {
        this.$message.success('删除成功')
        this.getList()
      })
    }
  }
}
</script>

<style scoped>
.table-page-search-wrapper {
  background: #f5f5f5;
  padding: 16px;
  border-radius: 4px;
}
</style>
